var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 248,
    height: 248,
    viewBox: "0 0 248 248",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 124,
    cy: 124,
    r: 124,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M185.011 85.8621C180.487 87.8666 175.628 89.221 170.519 89.8331C175.79 86.679 179.734 81.7148 181.614 75.8667C176.662 78.8084 171.241 80.879 165.589 81.9885C161.788 77.93 156.753 75.24 151.267 74.3361C145.78 73.4322 140.149 74.3649 135.247 76.9895C130.344 79.6141 126.446 83.7837 124.156 88.851C121.867 93.9182 121.314 99.5996 122.584 105.013C112.549 104.509 102.733 101.901 93.7708 97.3576C84.8091 92.8142 76.9028 86.4372 70.5651 78.6405C68.3981 82.3786 67.1521 86.7126 67.1521 91.3284C67.1497 95.4836 68.1729 99.5752 70.1311 103.24C72.0892 106.905 74.9217 110.03 78.3773 112.338C74.3698 112.21 70.4507 111.127 66.9462 109.179V109.504C66.9458 115.332 68.9617 120.981 72.6519 125.491C76.3421 130.002 81.4792 133.097 87.1916 134.252C83.474 135.258 79.5764 135.406 75.7931 134.685C77.4048 139.7 80.5443 144.085 84.772 147.226C88.9997 150.368 94.104 152.109 99.3703 152.205C90.4304 159.223 79.3897 163.03 68.0243 163.013C66.0111 163.014 63.9995 162.896 62 162.661C73.5365 170.079 86.9659 174.015 100.681 174C147.11 174 172.491 135.546 172.491 102.196C172.491 101.112 172.464 100.018 172.415 98.9346C177.352 95.3643 181.614 90.9432 185 85.8783L185.011 85.8621V85.8621Z",
    fill: "#8091B2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTwitter);
export default __webpack_public_path__ + "static/media/icon-twitter.4d348f9fd6d0d2748f332bd12db4b120.svg";
export { ForwardRef as ReactComponent };